var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isCustom
    ? _c("app-human-filter-edit-value-default", {
        attrs: {
          filter: _vm.filter,
          "field-type": _vm.fieldType,
          labels: _vm.labels,
          model: _vm.model,
          "disable-use-value-of-other-field": _vm.disableUseValueOfOtherField,
        },
      })
    : _c("app-human-filter-edit-value-custom", {
        attrs: {
          filter: _vm.filter,
          "field-type": _vm.fieldType,
          labels: _vm.labels,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }